import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";

interface IProps {
  name: string;
  size?: string;
  m_size?: string;
  bgColor?: string;
  fontSize?: string;
  m_fontSize?: string;
}
const BadgeIcon = ({
  name,
  size = "2.4",
  m_size = size,
  bgColor,
  fontSize = "",
  m_fontSize = fontSize
}: IProps) => {
  return (
    <Container bgcolor={bgColor} size={size} m_size={m_size}>
      <Typography m_size={m_fontSize} size={fontSize}>
        {name[0]}
      </Typography>
    </Container>
  );
};

export default BadgeIcon;

const Container = styled.div<{
  size?: string;
  m_size?: string;
  bgcolor?: string;
}>`
  width: ${(props) => `${props.size}rem`};
  height: ${(props) => `${props.size}rem`};
  border-radius: 50%;
  background-color: ${(props) =>
    props.bgcolor ? props.bgcolor : Colors.yellow500};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  text-transform: capitalize;

  @media only screen and (max-width: 769px) {
    width: ${(props) => `${props.m_size}rem`};
    height: ${(props) => `${props.m_size}rem`};
  }
`;
